// Page-load key identifying this browser tab in the online-time presence signal.
// Deliberately self-contained (no imports) and kept behaviourally identical to the Call Center
// portal's `src/shared/lib/getTabId.ts` — the two portals must be indistinguishable on the wire.

const TAB_ID_LENGTH = 12;
const TAB_ID_CHARACTERS = 'abcdefghijklmnopqrstuvwxyz0123456789';

const generateTabId = (): string => {
  let result = '';
  for (let i = 0; i < TAB_ID_LENGTH; i += 1) {
    result += TAB_ID_CHARACTERS.charAt(Math.floor(Math.random() * TAB_ID_CHARACTERS.length));
  }
  return result;
};

// Deliberately generated HERE, at module scope, and not inside the component:
//   - module scope runs exactly once per loaded document, so every online signal from this tab
//     carries the same key, and React StrictMode's double-invoke cannot mint a second one;
//   - a reload, a new tab, or closing and reopening the portal re-evaluates this module and so
//     yields a NEW key — which is exactly what the distinct-tab count needs;
//   - kept in memory ONLY. Nothing is written to sessionStorage (survives a reload),
//     localStorage or cookies (shared across tabs) — either would break the two rules above.
const TAB_ID = generateTabId();

const getTabId = (): string => TAB_ID;

export default getTabId;
